import i18next from "i18next";
import XHR from "i18next-xhr-backend";
import emp_en from "../translations/en";
import emp_es from "../translations/es";
import emp_es_MEX from "../translations/es_MEX";
import TranslationsClient from "../components/translations/TranslationsClient.js";
import { isLikelyJwt } from "../auth/tokenShape";

let failedLoadingHandlerAttached = false;

// i18next-xhr-backend issues raw XHR requests, which bypass the axios
// interceptor entirely. So unlike normal API calls, we must pass the
// access token explicitly at init time. Omit the auth header when the
// caller can't supply a JWT-shaped token — that way the translations
// service replies with a clean 401 instead of "Bearer null".
const i18n = (token = null) => {
  if (i18next.isInitialized) {
    return i18next;
  }

  const language = i18next.language || "es_MEX";

  const languageUrl = TranslationsClient.getDefaultLanguage();

  const backendOptions = {
    type: "backend",
    crossDomain: false,
    allowMultiLoading: false,
    loadPath: languageUrl + "{{lng}}",
    customHeaders: isLikelyJwt(token)
      ? { authorization: `Bearer ${token}` }
      : {},
  };

  const options = {
    initImmediate: false,
    debug: true,
    lng: language,
    fallbackLng: language,
    ns: ["emp"],
    defaultNS: "emp",
    react: {
      wait: true,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed",
      nsMode: "default",
      defaultTransParent: "div",
    },
  };

  const resources = {
    en: {
      emp: emp_en,
    },
    es: {
      emp: emp_es,
    },
    es_MEX: {
      emp: emp_es_MEX,
    },
  };

  // Bundled resources are loaded into the i18next store at init time.
  // i18next won't call the XHR backend for any language already present here.
  options["resources"] = {
    es_MEX: { emp: emp_es_MEX },
  };

  options["backend"] = backendOptions;

  i18next.use(XHR).init(options);

  if (!failedLoadingHandlerAttached) {
    i18next.on("failedLoading", function (lng, ns) {
      const safeLanguage = typeof lng === "string" ? lng : "";
      const resourceLng =
        safeLanguage === "es_MEX" ? safeLanguage : safeLanguage.slice(0, 2);

      const fallbackNamespace = resources[resourceLng]?.[ns] ? ns : "emp";

      if (resources[resourceLng]?.[fallbackNamespace]) {
        i18next.addResourceBundle(
          lng,
          fallbackNamespace,
          resources[resourceLng][fallbackNamespace],
          false,
          true
        );
      }
    });
    failedLoadingHandlerAttached = true;
  }

  return i18next;
};

export default i18n;
